import 'react-quill-new/dist/quill.snow.css'

import { useId, useState } from 'react'
import ReactQuill from 'react-quill-new'

import { designTokens } from '@/shared/lib/design-tokens'
import { normalizeRichTextHtml, cn } from '@/shared/lib'
import { typographyStyle } from '../lib/catalog'
import { Textarea } from './textarea'

const toolbarModules = {
  toolbar: [
    [{ header: [2, 3, false] }],
    ['bold', 'italic', 'underline'],
    [{ list: 'ordered' }, { list: 'bullet' }],
    ['link', 'blockquote'],
    ['clean'],
  ],
}

const editorFormats = [
  'header',
  'bold',
  'italic',
  'underline',
  'list',
  'bullet',
  'link',
  'blockquote',
]

const toggleButtonBaseClass =
  'rounded-full border px-3 py-1 text-xs font-semibold transition-colors'

export function HtmlEditor({
  value,
  onChange,
  className,
  placeholder = 'Введите описание',
}: {
  value: string
  onChange: (value: string) => void
  className?: string
  placeholder?: string
}) {
  const editorId = useId()
  const [mode, setMode] = useState<'rich' | 'html'>('rich')

  return (
    <div className={cn('flex flex-col gap-3', className)}>
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center gap-2">
          <button
            type="button"
            className={toggleButtonBaseClass}
            style={{
              borderColor:
                mode === 'rich'
                  ? designTokens.colors.border.inputFocus
                  : designTokens.colors.border.adminPattern,
              backgroundColor:
                mode === 'rich'
                  ? 'rgba(168, 133, 255, 0.12)'
                  : designTokens.colors.background.surface,
              color: designTokens.colors.text.strong,
            }}
            onClick={() => setMode('rich')}
          >
            Rich text
          </button>
          <button
            type="button"
            className={toggleButtonBaseClass}
            style={{
              borderColor:
                mode === 'html'
                  ? designTokens.colors.border.inputFocus
                  : designTokens.colors.border.adminPattern,
              backgroundColor:
                mode === 'html'
                  ? 'rgba(168, 133, 255, 0.12)'
                  : designTokens.colors.background.surface,
              color: designTokens.colors.text.strong,
            }}
            onClick={() => setMode('html')}
          >
            HTML
          </button>
        </div>
        <p
          className="text-right"
          style={{
            color: designTokens.colors.text.secondary,
            ...typographyStyle(designTokens.typography.body.sm),
          }}
        >
          Форматирование, списки и ссылки сохраняются в `descriptionHtml`.
        </p>
      </div>

      {mode === 'rich' ? (
        <div className="html-editor-surface">
          <ReactQuill
            id={editorId}
            theme="snow"
            value={normalizeRichTextHtml(value)}
            onChange={onChange}
            modules={toolbarModules}
            formats={editorFormats}
            placeholder={placeholder}
          />
        </div>
      ) : (
        <Textarea
          value={value}
          onChange={(event) => onChange(event.target.value)}
          rows={10}
          spellCheck={false}
          className="min-h-[220px] font-mono text-sm"
          placeholder="<p>Введите HTML описание</p>"
        />
      )}
    </div>
  )
}
